angular.module('Itao.IndicatorMap').factory('IndicatorCategoryService', function () {
  'use strict';

  /**
   * IndicatorCategory constructor
   * @param {Integer} uid uid of IndicatorCategory
   * @param {String} name name of IndicatorCategory
   * @param {IndicatorCategory} parent of this IndicatorCategory
   * @constructor
   */
  function IndicatorCategory(uid, name, parent, classIdentifier, sorting) {
    this.uid = uid;
    this.name = name;
    this.parent = parent;
    this.categories = [];
    this.class = classIdentifier;
    this.sorting = sorting;
  }

  return {
    createIndicatorCategory: function (uid, name, parent, classIdentifier, sorting) {
      return new IndicatorCategory(uid, name, parent, classIdentifier, sorting);
    }
  };
});
